<template>
  <div style="margin: auto; margin-top:60px;" class="col-md-4 card">
    <div class="card-body">
      <div
        style="border-bottom: 3px solid #272727; padding-bottom:10px; margin-bottom:10px;"
      >
        Sign in...
      </div>
      <div style="margin-top:50px;">
        <transition name="fade">
          <b-form @submit.prevent="sendResetAction" v-if="reset">
            <b-form-group>
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text"
                    ><i class="fa fa-user fa-lg"></i
                  ></span>
                </b-input-group-prepend>
                <b-form-input
                  id="txtEmailReset"
                  type="email"
                  autocomplete="email"
                  v-model="resetEmail"
                  v-bind:disabled="!show"
                  placeholder="Your Email Address"
                  style="border-radius: 0px;"
                />
              </b-input-group>
            </b-form-group>
            <p class="mt-3">
              <a
                href="#"
                id="hyperBackToLogin"
                @click.prevent="resetAction"
                style="color:#272727"
                >Go back to login</a
              >
            </p>
            <transition name="fade">
              <b-button
                class="m-1"
                id="btnReset"
                type="submit"
                variant="primary"
                style="background-color:#272727; border-color:#272727; border-radius: 0px;"
              >
                <span v-if="show">{{ resetButtonText }}</span>
                <font-awesome-icon icon="arrow-right" />
              </b-button>
            </transition>
          </b-form>
          <b-form @submit.prevent="loginAction" v-else>
            <b-form-group>
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text"
                    ><i class="fa fa-user fa-lg"></i
                  ></span>
                </b-input-group-prepend>
                <b-form-input
                  id="txtEmailLogin"
                  type="email"
                  autocomplete="email"
                  v-model="login.email"
                  v-bind:disabled="!show"
                  placeholder="Your Email Address"
                  style="border-radius: 0px;"
                />
              </b-input-group>
            </b-form-group>
            <b-form-group>
              <b-input-group>
                <b-input-group-prepend>
                  <span class="input-group-text"
                    ><i class="fa fa-key fa-lg"></i
                  ></span>
                </b-input-group-prepend>
                <b-form-input
                  id="txtPasswordLogin"
                  type="password"
                  autocomplete="password"
                  v-model="login.password"
                  v-bind:disabled="!show"
                  placeholder="Enter Your Password"
                  style="border-radius: 0px;"
                />
              </b-input-group>
            </b-form-group>
            <p class="mt-3">
              <a
                href="#"
                id="hyperForgotPassword"
                @click.prevent="resetAction"
                style="color:#272727"
                >Forgot your password?</a
              >
            </p>
            <transition name="fade">
              <b-button
                class="m-1"
                id="btnLogin"
                type="submit"
                variant="primary"
                style="background-color:#272727; border-color:#272727; border-radius: 0px;"
              >
                <span v-if="show">Log in</span>
                <span v-else>Logging in...</span>
                <font-awesome-icon icon="arrow-right" />
              </b-button>
            </transition>
          </b-form>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { login } from "../modules/auth";
import constants from "../modules/constants";
import router from "../modules/router";
export default {
  data: () => {
    return {
      login: {
        email: "",
        password: ""
      },
      resetEmail: "",
      show: true,
      success: null,
      reset: false,
      resetButtonText: constants.actions.send_reset,
      navigateAfterLogin: false,
      navigateTimeout: null
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      currentDashboardSubscription: "getCurrentDashboardSubscription"
    })
  },
  props: ["visible", "hide"],
  beforeDestroy() {
    clearTimeout(this.navigateTimeout);
  },
  mounted() {
    this.check_login();
  },
  methods: {
    loginAction() {
      if (!(this.login.email && this.login.password)) {
        this.$root.toast(constants.errors.fill_fields);
        return;
      }
      if (
        this.login.email.trim().length === 0 ||
        this.login.password.trim().length === 0
      ) {
        this.$root.toast(constants.errors.fill_fields);
        return;
      }
      this.show = false;
      login(this.login.email, this.login.password)
        .then(user => {
          this.navigateAfterLogin = true;
          //set timeout for navigation
          this.navigateTimeout = setTimeout(() => {
            this.navigateAfterLogin = false;
          }, 10000);
          this.$root.toast(
            "Welcome back, " +
              (user.displayName.split(" ")[0] || user.displayName) +
              "!"
          );
          if (this.$route.params.type == "general") {
            this.redirect_to_genral();
          }
          if (this.$route.params.type == "subscription") {
            this.redirect_to_subscriptions();
          } else {
            // console.log("check");
            router.go(-1);
          }
          this.hideAction();
        })
        .catch(() => {
          this.$root.toast(constants.errors["auth/wrong-password"]);
        })
        .finally(() => {
          this.login.email = "";
          this.login.password = "";
          this.show = true;
        });
    },
    resetAction() {
      this.reset = !this.reset;
    },
    hideAction() {
      if (typeof this.hide === "function") this.hide();
    },
    redirect_to_genral() {
      clearTimeout(this.navigateTimeout);
      // redirect("/settings/general");
      this.$router.push("/settings/general/app");
    },
    redirect_to_subscriptions() {
      clearTimeout(this.navigateTimeout);
      router.push("/settings/subscriptions/app");
    },
    check_login() {
      if (this.user !== null) {
        if (this.$route.params.type == "subscription") {
          this.redirect_to_subscriptions();
        }
        if (this.$route.params.type == "goBackTo") {
          router.go(-1);
        } else {
          this.redirect_to_genral();
        }
      }
    }
  },
  watch: {
    user() {
      if (this.user != null) {
        this.check_login();
      }
    },
    currentDashboardSubscription(newValue, oldValue) {
      if (
        newValue != null &&
        newValue.id !== undefined &&
        newValue.id !== null
      ) {
        if (oldValue === null && this.navigateAfterLogin) {
          //no previous dashboard subscription and navigation is marked after login
          this.navigateAfterLogin = false;
          clearTimeout(this.navigateTimeout);
          router.push("/settings/subscription/" + newValue.id + "/jobs");
        }
        //  if()
        // {
        //   this.navigateAfterLogin = false;
        //   clearTimeout(this.navigateTimeout);
        //   router.push("settings/subscriptions");
        // }
      }
    }
  }
};
</script>
<style>
#masthead .nav-link {
  color: #000 !important;
}
</style>
<style>
.artibot-wrapper--19YJW {
  display: none;
}
</style>
